/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { getAuthInstance } from '@/auth/authService'

export default {
  login ({ commit, state, dispatch }, payload) {

    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      return false
    }
  },

  fetchAccessToken({ commit, dispatch }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log('Fetching access token...');
        const authInstance = getAuthInstance();
        
        // Check if auth instance is available
        if (!authInstance) {
          throw new Error('Auth instance not available');
        }
        
        // Check if user is authenticated (with special case for callback page)
        const isOnCallbackPage = window.location.pathname === '/callback';
        const hasUser = authInstance.user && authInstance.user.sub;
        
        if (!authInstance.isAuthenticated && !(isOnCallbackPage && hasUser)) {
          throw new Error('User not authenticated');
        }
        
        const token = await authInstance.getTokenSilently();
        
        if (token && typeof token === 'string') {
          commit('SET_BEARER', token);
          console.log('Access token stored successfully');
          resolve(token);
        } else {
          throw new Error('Token is null or invalid');
        }
      } catch (e) {
        // Only logout if it's a token-related error, not if user is just not authenticated
        if (e.message !== 'User not authenticated') {
          console.log('Token error detected, logging out...');
          await dispatch('logout');
        }
        reject(e);
      }
    });
  },
  logout ({ commit }) {
    return new Promise(async (resolve) => {
      console.log('Clearing user session...');
      commit('SET_USER', null);
      commit('SET_BEARER', null);
      await getAuthInstance().logout();
      resolve();
    })
  },
  setUser ({ commit }, user) {
    return new Promise(async (resolve) => {
      commit('SET_USER', user);

      resolve();
    })
  },
  setAccessDenied ({ commit }, accessDenied) {
    return new Promise(async (resolve) => {
      commit('SET_ACCESS_DENIED', accessDenied);
      resolve();
    })
  },
  setPasswordExpired ({ commit }, passwordExpired) {
    return new Promise(async (resolve) => {
      commit('SET_PASSWORD_EXPIRED', passwordExpired);
      resolve();
    })
  }
}
